import { MedicationPage } from "./medication";

export const MedicationsPage = MedicationPage;
